import { useTranslation } from 'react-i18next'

import { MonetizationIcon, Tag } from '@mercai/clever'

import { CardInfo } from '@/components/card-info'
import { DECIMAL_PLACES_DEFAULT } from '@/constants'
import { CardOrderProductsCostsProps } from './card-order-products-costs.type'

import styles from './card-order-products-costs.module.css'
import { formatCurrency, formatNumber } from '@/helpers'

export const CardOrderProductsCosts = ({
  isLoading,
  dollarQuotation,
  supplierName,
  item,
  actions,
}: CardOrderProductsCostsProps) => {
  const { t: tEnums } = useTranslation('enums')
  const { t } = useTranslation('componentCardsOrderCenterShow')

  return (
    <CardInfo
      icon={<MonetizationIcon />}
      title={t('cardOrderProductsCostsTitle')}
      isLoading={isLoading}
      className={styles.core}
      actions={actions}
      items={[
        {
          label: t('cardOrderProductsCostsQuantity'),
          value: item?.quantity ? (
            <div className={styles.row}>
              {formatNumber(item?.quantity)}
              <Tag
                size="small"
                variant="secondary"
                className={styles['table-item-packaging']}
              >
                {item?.package &&
                  tEnums(`order_itens_package_${item?.package}`)}
              </Tag>
            </div>
          ) : (
            '-'
          ),
        },
        {
          label: t('cardOrderProductsCostsUnitPrice'),
          value: (
            <>
              {formatCurrency(
                +(item?.price || 0) * +dollarQuotation,
                'es-MX',
                'MXN',
                DECIMAL_PLACES_DEFAULT,
              )}{' '}
              ({formatCurrency(item?.price || 0, 'es-MX', 'USD', DECIMAL_PLACES_DEFAULT)})
            </>
          ),
        },
        {
          label: t('cardOrderProductsCostsTotalPrice'),
          value: (
            <>
              {formatCurrency(
                +(item?.quantity || 0) * +(item?.price || 0) * +dollarQuotation,
                'es-MX',
                'MXN',
              )}{' '}
              (
              {formatCurrency(
                +(item?.quantity || 0) * +(item?.price || 0),
                'es-MX',
                'USD',
              )}
              )
            </>
          ),
        },
        {
          label: t('cardOrderProductsCostsUnitCost'),
          value: (
            <>
              {item?.cost ? (
                <>
                  {formatCurrency(
                    +item.cost * +dollarQuotation,
                    'es-MX',
                    'MXN',
                    DECIMAL_PLACES_DEFAULT,
                  )}{' '}
                  ({formatCurrency(item.cost, 'es-MX', 'USD', DECIMAL_PLACES_DEFAULT)})
                </>
              ) : (
                <>{t('cardOrderProductsCostsNoData')}</>
              )}
            </>
          ),
        },
        {
          label: t('cardOrderProductsCostsTotalCost'),
          value: (
            <>
              {item?.cost ? (
                <>
                  {formatCurrency(
                    +item.quantity * +item.cost * +dollarQuotation,
                    'es-MX',
                    'MXN',
                  )}{' '}
                  ({formatCurrency(+item.quantity * +item.cost, 'es-MX', 'USD')}
                  )
                </>
              ) : (
                <>{t('cardOrderProductsCostsNoData')}</>
              )}
            </>
          ),
        },
        {
          label: t('cardOrderProductsCostsTraderComission'),
          value: (
            <>
              {formatCurrency(
                +(item?.traderCommission || 0) * +dollarQuotation,
                'es-MX',
                'MXN',
              )}{' '}
              ({formatCurrency(+(item?.traderCommission || 0), 'es-MX', 'USD')})
            </>
          ),
        },
        {
          label: t('cardOrderProductsCostsSupplier'),
          value: <>{supplierName || t('cardOrderProductsCostsNoData')}</>,
        },
      ]}
    />
  )
}
